app.controller('historyPurchasingCtrl', function ($scope, urlServices, $filter, toaster, _VAR_GLOBAL, _API_URL, $window) {
    $scope.filter = '';
    $scope.hasSubmitted = false;
    $scope.activeSettings = null;
    $scope.datePicker = {
        startDate: moment().subtract(30, 'days'),
        endDate: moment()
    };
    $scope.dataList = {
        totalItems: 0,
        data: []
    };
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: _VAR_GLOBAL.limit,
        sort: null
    };

    function formatPeriodSetting(setting) {
        if (!setting) {
            return '-';
        }
        return [String(setting.mode || '-'), String(setting.lookback || '-'), String(setting.unit || '-')].join(' / ');
    }

    $scope.getActiveSettingsSummary = function () {
        var settings = $scope.activeSettings || {};
        var dist = settings.priorityDistribution || {};
        return {
            rankPeriod: formatPeriodSetting(settings.rankPeriod),
            previousPricePeriod: formatPeriodSetting(settings.previousPricePeriod),
            distribution: 'P1 ' + (dist.p1 || 0) + '% | P2 ' + (dist.p2 || 0) + '% | P3 ' + (dist.p3 || 0) + '% | P4 ' + (dist.p4 || 0) + '%',
            categoryCount: (settings.categoryCodes || []).length
        };
    };

    $scope.loadSettings = function () {
        urlServices.ambilData('api/report/purchase-history-settings', {}, function (err, sukses) {
            if (err) {
                $scope.activeSettings = null;
                return;
            }
            $scope.activeSettings = sukses.data ? sukses.data : sukses;
        });
    };

    $scope.viewData = function (pg, excel) {
        if (!$scope.hasSubmitted) {
            return;
        }
        $scope.paginationOptions.pageNumber = pg;
        if (excel) {
            $scope.getData(100000, $scope.paginationOptions.pageNumber, $scope.filter, excel);
        } else {
            $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter, excel);
        }
    };

    $scope.excelReport = function () {
        if (!$scope.hasSubmitted) {
            toaster.pop('error', 'Error', 'Silakan klik Tampilkan terlebih dahulu');
            return;
        }
        $scope.viewData(1, true);
    };

    $scope.tampilkan = function () {
        var start = moment($scope.datePicker.startDate);
        var end = moment($scope.datePicker.endDate);
        if (!start.isValid() || !end.isValid()) {
            toaster.pop('error', 'Error', 'Periode belum valid');
            return;
        }
        if (end.isBefore(start)) {
            toaster.pop('error', 'Error', 'Tanggal akhir tidak boleh lebih kecil dari tanggal awal');
            return;
        }
        $scope.hasSubmitted = true;
        $scope.paginationOptions.pageNumber = 1;
        $scope.getData($scope.paginationOptions.pageSize, 1, $scope.filter, false);
    };

    $scope.resetFilter = function () {
        $scope.filter = '';
        $scope.hasSubmitted = false;
        $scope.datePicker = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.paginationOptions.pageNumber = 1;
        $scope.dataList.totalItems = 0;
        $scope.dataList.data = [];
    };

    $scope.onFilterChange = function () {
        if (!$scope.hasSubmitted) {
            return;
        }
        $scope.viewData(1, false);
    };

    $scope.getData = function (pageSize, page, searchText, excel) {
        setTimeout(function () {
            var start = moment($scope.datePicker.startDate);
            var end = moment($scope.datePicker.endDate);
            var data = 'limit=' + pageSize +
                '&pg=' + page +
                '&start_date=' + start.format('YYYY-MM-DD') +
                '&end_date=' + end.format('YYYY-MM-DD');

            if (searchText) {
                data += '&term=' + encodeURIComponent(searchText.toLowerCase());
            }

            if (excel) {
                data += '&excel=true';
                $window.open(_API_URL + 'api/report/purchase-history?' + data);
            } else {
                urlServices.ambilData('api/report/purchase-history?' + data, {}, function (err, sukses) {
                    if (err) {
                        toaster.pop('error', 'Error', err);
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = [];
                        $scope.activeSettings = null;
                    } else {
                        $scope.dataList.totalItems = sukses.records;
                        $scope.dataList.data = sukses.data;
                        $scope.activeSettings = sukses.settings || null;
                    }
                })
            }
        }, 100);
    };

    $scope.loadSettings();
});
